import {
  GetObraServicosControladosDropDown,
  GetObraServicosControladosDropDownResponse,
} from "../../../data/daos/read/get_obra_servicos_controlados_dropdown";
import { IObraServicosControladosDropDownUseCase } from "../../../presentation/useCases/read/obra_servicos_controlados_drop_down_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * ObraServicosControladosDropDownUseCase
 */
export class ObraServicosControladosDropDownUseCase implements IObraServicosControladosDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async obraServicosControladosDropDown(id?: number): Promise<GetObraServicosControladosDropDown[]> {
    const response = await this.repository.obrasServicosControladosDropdown({ id });
    return response;
  }
}
